import React, { useEffect, useState } from 'react'

const Percentagering = ({percentage}) => {
 
      const circleStyle = {
        background: `conic-gradient(#7E7E7E ${percentage * 3.6}deg, #EDEDED ${
          percentage * 3.6
        }deg)`,
      };
useEffect(()=>{
  console.log('mypercentage',percentage)
},[percentage])
      

  return (

         <div
            className="relative flex justify-center items-center w-[60px] h-[60px] rounded-full"
            style={circleStyle}
          >
            <div className="flex justify-center items-center w-[50px] h-[50px] bg-[#FFFFFF] rounded-full">
              <div className=" [font-family:'Roboto-SemiBold',Helvetica] font-semibold text-[#1d2951] text-xs tracking-[0] leading-[normal] whitespace-nowrap">
                {percentage}%
              </div>
            </div>
          </div> 
  
  )
}

export default Percentagering
